<template>
  <div class="page-wrapper">
    <Navbar />
    <div class="page-content">
      <transition @after-leave="beforeEnter">
        <router-view />
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "DefaultAppView",
  components: {
    Navbar,
    Footer
  },
  methods: {
    beforeEnter() {
      this.$root.$emit("scrollBeforeEnter");
    }
  }
};
</script>

<style>
:root {
  --default-bg: #f0f4f9;
  --footer-bg: #d5dde7;
}

/* This might break everything on ios; puts footer to bottom */
html,
body,
#app,
.page-wrapper {
  height: 100%;
}

.page-wrapper {
  display: flex;
  flex-direction: column;
}

.page-wrapper > * {
  flex: 0 0 auto;
}

.page-content {
  flex: 1 0 auto;
}
/* ------------------------------------------------------------*/

.error,
.loading {
  padding: 2em;
}

html,
body {
  margin: 0;
}

body {
  background-color: #e9eef7;
  background-color: var(--default-bg);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.21s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.button {
  background: hsla(111, 40%, 46%, 1);
  background: hsla(111, 54%, 41%, 1);
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 2px 4px 0 rgba(14, 30, 37, 0.12);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: inherit;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.618em;
  outline: 0;
  padding: 0.382em 1em;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: all 0.15s ease, transform 0.05s linear;
  vertical-align: middle;
  z-index: 1;
  will-change: background-color, box-shadow, transform;
  border: 1px solid transparent;
  box-sizing: content-box;
}

.button:hover,
.button:focus {
  background: hsla(111, 54%, 44%, 1);
  text-decoration: none;
}

.button:active {
  background: hsla(111, 54%, 25%, 1);
  border-color: hsla(0, 0%, 100%, 0.05);
}

a, a:visited {
  color: #2b4a94;
}

strong {
  font-weight: 500;
}

.independent {
    font-weight: 400!important;
    text-align: center!important;
}

.container {
  margin: 1em auto 2.4em auto;
  max-width: 650px;
  padding: 0 calc(2.5em + 3vw);
  position: relative;
}

.defaultheading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  font-weight: 700;
  color: #2d2f34;
}

h1 {
  font-size: 3.3em;
  letter-spacing: -1px;
  text-align: center;
}

.container p {
  font-size: 1.4em;
  line-height: 1.7;
  font-weight: 400;
  text-align: left;
  color: #05060a;
}

.container h3 {
  text-align: left;
  font-size: 1.6em;
  line-height: 1.33;
  margin: 0;
  color: #171b31;
  font-weight: 600;
}

p.content {
  margin-top: 0.5em;
  font-weight: 300;
  font-size: 1.1em;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  background: rgba(11, 15, 11, 0.6);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  color: white;
  border-radius: 10px;
  padding: 6px 11px 7px;
  font-family: "Inter", Arial, Helvetica, sans-serif;
  font-weight: 300;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 7px;
  border-color: rgba(11, 15, 11, 0.4);
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 7px;
  top: 40px !important;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 7px 7px 0 7px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -7px;
  left: calc(50% - 7px);
  margin-top: 0px;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 7px;
  top: -10px !important;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 7px 7px 7px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -7px;
  left: calc(50% - 7px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 7px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 7px 7px 7px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -7px;
  top: calc(50% - 7px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 7px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 7px 0 7px 7px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -7px;
  top: calc(50% - 7px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 7px;
  box-shadow: 0 7px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

@media screen and (max-width: 650px) {
  h1 {
    font-size: 10vw;
  }
}
</style>
